import K from '../constants/CelebritiesConstants';

const init = {
    items: []
};

export default function reducer(state = init, action) {
    switch (action.type) {
        case K.GET_CELEBRITIES:
            return {
                ...state,
                items: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/CelebritiesReducer.js